/** Map the saved editor form to Flask's explicit test-email contract. */
export const birthdayEmailPreview = values => {
  const preview = typeof values.preview === 'string' ? JSON.parse(values.preview) : values.preview;
  if (!preview || typeof preview !== 'object') return values;
  if (preview.body_html) return {...values, preview: JSON.stringify(preview)};
  const html = preview.preview || '';
  const text = html.replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  return {...values, id: preview.id, preview: JSON.stringify({subject:preview.subject || '',body_html:html,body_text:text || preview.subject || ''})};
};
